import WhatsAppIcon from '@/components/icons/WhatsAppIcon'
import { WHATSAPP_URL } from '@/data/contact'

export default function WhatsAppButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Nous écrire sur WhatsApp"
      className="animate-whatsapp-pulse fixed right-4 bottom-8 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full shadow-xl flex items-center justify-center transition-colors active:scale-95"
    >
      <WhatsAppIcon size={28} />
    </a>
  )
}
